import { render, staticRenderFns } from "./DecoVoteComponent.vue?vue&type=template&id=019d4901&"
import script from "./DecoVoteComponent.vue?vue&type=script&lang=ts&"
export * from "./DecoVoteComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DecoVoteComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports